import apiClient, {errorHandling, errorConsole} from '../apiClient';

const ofertasServices = {
  obtenerOfertas: async () => {
    try {
      const response = await apiClient.get(`/ofertas`);

      return response.data;
    } catch (error) {
      errorHandling(error)
      errorConsole(error, 'ofertas')
      throw error;
    }
  },
  obtenerOfertaPorId: async (id) => {
    try {
      const response = await apiClient.get(`/ofertas/${id}`);

      return response.data;
    } catch (error) {
      // errorHandling(error)
      errorConsole(error, 'ofertas')
      throw error;
    }
  },
  obtenerCategorias: async () => {
    try {
      const response = await apiClient.get(`/categorias`);

      return response.data;
    } catch (error) {
      errorHandling(error)
      errorConsole(error, 'categorias')
      throw error;
    }
  },
  obtenerCargos: async () => {
    try {
      const response = await apiClient.get(`/cargos`);

      return response.data;
    } catch (error) {
      errorHandling(error)
      errorConsole(error, 'cargos')
      throw error;
    }
  },
  actualizarOferta: async (id, params) => {
    try {
      const response = await apiClient.put(`/ofertas/${id}`, params, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 300000, // 5 minutos
        onUploadProgress: (progressEvent) => {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          console.log(`Progreso: ${percent}%`);
        },
      });

      return response.data;
    } catch (error) {
      // errorHandling(error)
      // errorConsole(error, 'ofertas')
      throw error;
    }
  },
  nuevaOferta: async () => {
    try {
      const response = await apiClient.post(`/ofertas/new`);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  crearOferta: async (params) => {
    try {
      const response = await apiClient.post(`/ofertas/`, params, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 300000, // 5 minutos
        onUploadProgress: (progressEvent) => {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          console.log(`Progreso: ${percent}%`);
        },
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  agregarMaterialPostulante: async (oferta_id, adjunto) => {
    try {
      const formData =  new FormData();
      formData.append('oferta[material_postulantes][]', adjunto)

      const response = await apiClient.post(`/ofertas/${oferta_id}/agregarMaterialPostulante`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  eliminarMaterialPostulante: async (oferta_id, adjunto_id) => {
    try {
      const response = await apiClient.delete(`/ofertas/${oferta_id}/eliminarMaterialPostulante/${adjunto_id}`);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  eliminarOferta: async (id) => {
    try {
      const response = await apiClient.delete(`/ofertas/${id}`);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  eliminarAdjuntoOferta: async (id, adjunto_id) => {
    try {
      const response = await apiClient.delete(`/ofertas/${id}/eliminarAdjunto/${adjunto_id}`);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  crearPostulacion: async (postulacion) => {
    try {
      const formData =  new FormData();
      formData.append('postulacion[usuario_id]', postulacion.usuario_id)
      formData.append('postulacion[oferta_id]', postulacion.oferta_id)
      formData.append('postulacion[estado_condiciones]', postulacion.estado_condiciones)

      for(let index = 0; index < postulacion.archivos_adjuntos.length; index++){
        if(postulacion.archivos_adjuntos[index].name){
          formData.append('postulacion[adjuntos][]', postulacion.archivos_adjuntos[index])
        }
      }

      for(let index = 0; index < postulacion.adjuntos_postulaciones.length; index++){
        if(postulacion.adjuntos_postulaciones[index].documentacion_id){
          formData.append(`postulacion[adjuntos_postulaciones_attributes][]`, `{documentacion_id: ${postulacion.adjuntos_postulaciones[index].documentacion_id}}`)
        }
      }

      const response = await apiClient.post(`/postulaciones/`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  misPostulaciones: async () => {
    try {

      const response = await apiClient.get(`/postulaciones/misPostulaciones`);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  borrarPostulacion: async (id) => {
    try {
      const response = await apiClient.delete(`/postulaciones/${id}`);

      return response.data;
    } catch (error) {
      errorHandling(error)
      errorConsole(error, 'ofertas')
      throw error;
    }
  },
  eliminarAdjunto: async (id, adjunto_id) => {
    try {
      const response = await apiClient.delete(`/postulaciones/${id}/eliminarAdjunto/${adjunto_id}`);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  tiposOfertas: async () => {
    try {
      const response = await apiClient.get(`/ofertas/obtenerTipos`);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default ofertasServices;
